/**
 * The GAM publisher-provided identifier for this session.
 *
 * @returns {string}
 */

// @see WP-1061 regarding reuse of BlueConic ID.
// @ts-nocheck
let returnString = '';
if (null != window?.NXSTdata?.identity?.nexstarId) {
  returnString = window?.NXSTdata?.identity?.nexstarId;
} else if (window?.NXSTdata?.identity?.blueconicId) {
  returnString = window?.NXSTdata?.identity?.blueconicId;
}

export default String(returnString);
